import { createBrowserRouter, Navigate } from "react-router-dom";
import Main from "../pages/main";
import EmailConfig from "../pages/emailConfig";
import Home from "../pages/home"
import UserInfo from "../pages/userInfo";
import MatchResult from "../pages/matchResult";
import Assistance from "../pages/assistance";
import Donation from "../pages/donation";
import Upgrade from "../pages/upgrade";
import Login from "../pages/login";
import OauthConfig from "../pages/oauthConfig";
// import PersonalCenter from "../pages/personalCenter";


const routes = [
    {
        path:'/',
        Component:Main,
        children:[
            {
                path:"/",
                element:<Navigate to = "home"/>
            },
            {
                path:'home',
                Component:Home
            },
            {
                path:'oauthConfig',
                Component:OauthConfig
            },
            {
                path:'emailConfig',
                Component:EmailConfig
            },
            {
                path:'donation',
                Component:Donation
            },
            {
                path:'assistance',
                Component:Assistance
            },
            {
                path:'upgrade',
                Component:Upgrade
            },
            {
                path:'userInfo',
                Component:UserInfo
            },
            {
                path:'matchResult',
                Component:MatchResult
            }
        ]
    },
    {
        path: "/login",
        Component: Login,
    }
]

export default createBrowserRouter(routes)